// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3192":"css/app.6795","6958":"css/admin-app.6795"}[chunkId] + ".css";
};